module.exports = __webpack_public_path__ + "static/media/Kiki_Main.544d39bd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Kiki_Main.webp
// module id = ./src/assets/Kiki_Main.webp
// module chunks = 0